/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FormState } from '../models';
import moment from 'moment';

interface IFilterBiometricsContext {
  form: FormState;
  setForm: React.Dispatch<React.SetStateAction<FormState>>;
  list: any[];
  setList: React.Dispatch<React.SetStateAction<any[]>>;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

export const FilterBiometricsContext = createContext<IFilterBiometricsContext>(
  {} as IFilterBiometricsContext,
);

export const FilterBiometricProvider = ({ children }) => {
  const [list, setList] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const prevLocationRef = useRef<string | null>(null);
  const [form, setForm] = useState<FormState>({
    cpf: { masked: '', unmasked: '' },
    origem: 'TODAS',
    resultLiveness: 'TODOS',
    baseResultFace: 'TODOS',
    dataBiometriaInicial: moment().format('DD/MM/YYYY'),
    dataBiometriaFinal: moment().format('DD/MM/YYYY'),
    biometriaType: 'banknow',
    codigoAutenticacao: 'TODOS',
    codigoComportamento: 'TODOS',
    status: 'TODOS',
    nome: '',
  });

  const location = useLocation();

  const resetContext = () => {
    setForm({
      cpf: { masked: '', unmasked: '' },
      origem: 'TODAS',
      resultLiveness: 'TODOS',
      baseResultFace: 'TODOS',
      dataBiometriaInicial: moment().format('DD/MM/YYYY'),
      dataBiometriaFinal: moment().format('DD/MM/YYYY'),
      biometriaType: 'banknow',
      codigoAutenticacao: 'TODOS',
      codigoComportamento: 'TODOS',
      status: 'TODOS',
    });
    setList([]);
    setCurrentPage(1);
  };

  useEffect(() => {
    const { pathname } = location;
    const prevLocation = prevLocationRef.current;

    const isConsultationRoute = pathname === '/consult/user/biometrics';
    const isDetailRoute = pathname === '/consult/user/biometrics/detail';
    const isUnicoDetailRoute =
      pathname === '/consult/user/biometrics/unico/detail';
    const isBankNowDetailRoute =
      pathname === '/consult/user/biometrics/banknow/detail';

    if (
      prevLocation &&
      prevLocation !== pathname &&
      !isConsultationRoute &&
      !isDetailRoute &&
      !isUnicoDetailRoute &&
      !isBankNowDetailRoute
    ) {
      resetContext();
    }
    prevLocationRef.current = pathname;
  }, [location.pathname]);

  useEffect(() => {
    if (!form.origem) {
      setForm((prev) => ({
        ...prev,
        origem: 'TODAS',
        resultLiveness: 'TODOS',
        baseResultFace: 'TODOS',
      }));
    }
  }, [form]);

  return (
    <FilterBiometricsContext.Provider
      value={{
        form: {
          ...form,
          dataBiometriaFinal: form.dataBiometriaFinal
            ? form.dataBiometriaFinal
            : '',
          dataBiometriaInicial: form.dataBiometriaInicial
            ? form.dataBiometriaInicial
            : '',
        },
        setForm,
        list,
        setList,
        currentPage,
        setCurrentPage,
      }}
    >
      {children}
    </FilterBiometricsContext.Provider>
  );
};

export const useFilterBiometrics = () => useContext(FilterBiometricsContext);
